import styled from "@emotion/styled";
import { errorRed as errorColor, black } from "../styles";

export const Label = styled.label(
  ({ isError }: { isError?: boolean }) => `
    display: block;
    color: ${isError ? errorColor : black};
  `
);
